import React from "react";
import { Route, Redirect } from "react-router-dom";
import { Subscription } from 'rxjs';
import {AuthService} from "../services/authentication/AuthService";

export class AuthenticatedRoute extends React.Component<any, any> {
    private subscription: Subscription | null = null;
    constructor(props: any){
        super(props);

        this.state = {
            authenticated: AuthService.getInstance().isLogged()
        }
    }

    componentDidMount(){
        this.subscription = AuthService.getInstance().getUserAuthedObservable().subscribe((value) => {
            //@ts-ignore
            this.setState({authenticated: value});
        })
    }

    componentWillUnmount(){
        if(this.subscription !== null){
            this.subscription.unsubscribe();
        }
    }

    render(){
        //@ts-ignore
        let { component: Component, ...rest } = this.props;
        
        return (
            <Route
                {...rest}
                //@ts-ignore
                render={(props) => this.state.authenticated
                    //@ts-ignore
                    ? <Component {...props} />
                    : <Redirect to={{pathname: '/login', state: {from: props.location}}} />}
            />
        )
    }
}